var _style, _defs, _defs2, _defs3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTransferThankYouAddMoneyBg = function SvgTransferThankYouAddMoneyBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    id: "transfer-thank-you-add-money-bg_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 544 326"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".transfer-thank-you-add-money-bg_svg__st1{clip-path:url(#transfer-thank-you-add-money-bg_svg__SVGID_2_)}.transfer-thank-you-add-money-bg_svg__st3{clip-path:url(#transfer-thank-you-add-money-bg_svg__SVGID_6_);fill:none;stroke:#fff}.transfer-thank-you-add-money-bg_svg__st4,.transfer-thank-you-add-money-bg_svg__st5,.transfer-thank-you-add-money-bg_svg__st6{clip-path:url(#transfer-thank-you-add-money-bg_svg__SVGID_4_);fill:#169b62}.transfer-thank-you-add-money-bg_svg__st5,.transfer-thank-you-add-money-bg_svg__st6{fill:#fff}.transfer-thank-you-add-money-bg_svg__st6{fill:#41ad49}.transfer-thank-you-add-money-bg_svg__st10{font-family:\"Poppins\"}.transfer-thank-you-add-money-bg_svg__st11{font-size:54.8173px}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "transfer-thank-you-add-money-bg_svg__SVGID_1_",
    d: "M0 0h544v326H0z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "transfer-thank-you-add-money-bg_svg__SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#transfer-thank-you-add-money-bg_svg__SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h544v326H0z",
    style: {
      clipPath: "url(#transfer-thank-you-add-money-bg_svg__SVGID_2_)",
      fill: "#21233c"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "transfer-thank-you-add-money-bg_svg__st1"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "transfer-thank-you-add-money-bg_svg__SVGID_3_",
    d: "M0 0h544v326H0z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "transfer-thank-you-add-money-bg_svg__SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#transfer-thank-you-add-money-bg_svg__SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      clipPath: "url(#transfer-thank-you-add-money-bg_svg__SVGID_4_)"
    }
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "transfer-thank-you-add-money-bg_svg__SVGID_5_",
    d: "M8.2-102.3h531.2v531.2H8.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "transfer-thank-you-add-money-bg_svg__SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#transfer-thank-you-add-money-bg_svg__SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 273.8,
    cy: 163.2,
    r: 96,
    className: "transfer-thank-you-add-money-bg_svg__st3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 273.8,
    cy: 163.2,
    r: 64,
    className: "transfer-thank-you-add-money-bg_svg__st3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 273.8,
    cy: 163.3,
    r: 130.6,
    className: "transfer-thank-you-add-money-bg_svg__st3"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 273.8,
    cy: 163.3,
    r: 168.4,
    className: "transfer-thank-you-add-money-bg_svg__st3"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 273.8,
    cy: 163.3,
    r: 213.9,
    className: "transfer-thank-you-add-money-bg_svg__st3"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 273.8,
    cy: 163.3,
    r: 264.1,
    className: "transfer-thank-you-add-money-bg_svg__st3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.5 299c16.3 0 29.5-13.2 29.5-29.5S102.8 240 86.5 240 57 253.2 57 269.5 70.2 299 86.5 299",
    className: "transfer-thank-you-add-money-bg_svg__st4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93 209c14.4 0 26-11.6 26-26s-11.6-26-26-26-26 11.6-26 26 11.6 26 26 26",
    className: "transfer-thank-you-add-money-bg_svg__st5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M384 201c14.4 0 26-11.6 26-26s-11.6-26-26-26-26 11.6-26 26 11.6 26 26 26",
    className: "transfer-thank-you-add-money-bg_svg__st6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M424 81c10.5 0 19-8.5 19-19s-8.5-19-19-19-19 8.5-19 19 8.5 19 19 19",
    className: "transfer-thank-you-add-money-bg_svg__st4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M191 289c11.6 0 21-9.4 21-21s-9.4-21-21-21-21 9.4-21 21 9.4 21 21 21",
    className: "transfer-thank-you-add-money-bg_svg__st6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5 89C99.1 89 115 73.1 115 53.5S99.1 18 79.5 18 44 33.9 44 53.5 59.9 89 79.5 89",
    className: "transfer-thank-you-add-money-bg_svg__st4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M193.5 110c16.3 0 29.5-13.2 29.5-29.5S209.8 51 193.5 51 164 64.2 164 80.5s13.2 29.5 29.5 29.5",
    className: "transfer-thank-you-add-money-bg_svg__st5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M238 138c-5.4 7.4-8.6 16.5-8.6 26.4h4.4c0-8.9 2.9-17.2 7.8-23.9h-.1zm-4.3 26.4h-4.4c0 11 3.9 21 10.5 28.8l.1-.1c-.1-.1-.2-.2-.2-.3l3.3-2.8c-5.8-6.9-9.3-15.8-9.3-25.6",
    style: {
      clipPath: "url(#transfer-thank-you-add-money-bg_svg__SVGID_4_)",
      fill: "#91de63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.8 119.7c-14.7.1-27.7 7.2-35.9 18.2h.1l3.5 2.6c7.3-9.9 19.1-16.3 32.4-16.4h-.1z",
    style: {
      clipPath: "url(#transfer-thank-you-add-money-bg_svg__SVGID_4_)",
      fill: "#f6fbf9"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M273.8 119.7v4.4h.1c22.2 0 40.1 18.1 40.1 40.3 0 9.7-3.4 18.6-9.2 25.6l3.2 2.7-.2.2.1.1c6.5-7.7 10.4-17.7 10.4-28.6 0-24.6-19.9-44.6-44.4-44.7z",
    className: "transfer-thank-you-add-money-bg_svg__st4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M304.7 189.9c-7.4 8.9-18.5 14.5-30.9 14.5-12.3 0-23.4-5.6-30.8-14.4l-.1.1-3.3 2.8c.1.1.2.2.2.3 8.2 9.6 20.3 15.6 33.9 15.6 13.7 0 25.9-6.2 34.1-15.9l.2-.2-3.2-2.7z",
    className: "transfer-thank-you-add-money-bg_svg__st4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M268.8 168.3h9v-6.2h-9v-3.5c0-4.1 2.2-6.7 5.5-6.7 2.8 0 4.7 1.7 5.3 4.8h6.2c-.7-6.8-5.1-11-11.4-11-6.9 0-11.5 5.1-11.5 12.9v3.5H260v6.2h2.7v8.7H260v6.2h25V177h-16.3v-8.7z",
    className: "transfer-thank-you-add-money-bg_svg__st5"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "transfer-thank-you-add-money-bg_svg__st1"
  }, /*#__PURE__*/React.createElement("text", {
    className: "transfer-thank-you-add-money-bg_svg__st10 transfer-thank-you-add-money-bg_svg__st11",
    style: {
      fill: "#8fdb63"
    },
    transform: "translate(172 229.209)"
  }, "+")), /*#__PURE__*/React.createElement("g", {
    className: "transfer-thank-you-add-money-bg_svg__st1"
  }, /*#__PURE__*/React.createElement("text", {
    className: "transfer-thank-you-add-money-bg_svg__st10 transfer-thank-you-add-money-bg_svg__st11",
    style: {
      fill: "#41ad49"
    },
    transform: "translate(338 79.209)"
  }, "+")), /*#__PURE__*/React.createElement("g", {
    className: "transfer-thank-you-add-money-bg_svg__st1"
  }, /*#__PURE__*/React.createElement("text", {
    className: "transfer-thank-you-add-money-bg_svg__st10 transfer-thank-you-add-money-bg_svg__st11",
    style: {
      fill: "#fff"
    },
    transform: "translate(93 143.208)"
  }, "+")), /*#__PURE__*/React.createElement("g", {
    className: "transfer-thank-you-add-money-bg_svg__st1"
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "transfer-thank-you-add-money-bg_svg__SVGID_7_",
    d: "M0 0h544v326H0z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "transfer-thank-you-add-money-bg_svg__SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#transfer-thank-you-add-money-bg_svg__SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M462 294c14.4 0 26-11.6 26-26s-11.6-26-26-26-26 11.6-26 26 11.6 26 26 26",
    style: {
      clipPath: "url(#transfer-thank-you-add-money-bg_svg__SVGID_8_)",
      fill: "#fff"
    }
  })));
};
export { SvgTransferThankYouAddMoneyBg as ReactComponent };
export default __webpack_public_path__ + "images/transfer-thank-you-add-money-bg.svg";